import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-manufacturer',
  templateUrl: './product-manufacturer.component.html',
  styleUrls: ['./product-manufacturer.component.scss']
})
export class ProductManufacturerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
